// Apollo
import { apolloClient } from '@/vue-apollo'
// GraphQL
import getFavorites from '@/graphql/getFavorites.gql'
import getAdverts from '@/graphql/getAdverts.gql'
import gql from 'graphql-tag'
// // Config environments
import { config } from '@/config'

const actions = {
  async getFavorites (context) {
    let phone = localStorage.getItem('CognitoIdentityServiceProvider.' + config.userPoolWebClientId + '.LastAuthUser')
    let dataUser = localStorage.getItem('CognitoIdentityServiceProvider.' + config.userPoolWebClientId + '.' + phone + '.userData')
    let dataUserJson = JSON.parse(dataUser)

    let id = dataUserJson.UserAttributes.find(item => item.Name === 'sub').Value

    await apolloClient.query({
      query: gql`${getFavorites}`,
      variables: { id }
    }).then(response => {
      const query = response.data

      context.commit('setFavorites', query.companies)
    })
  },
  async insertFavorites (context, data) {
    await apolloClient.mutate({
      mutation: gql`mutation insertFavorites($cnpj: String!) {
        insert_favorites(
          objects: {
            company_cnpj: $cnpj
          }
        ) {
          affected_rows
        }
      }`,
      variables: {
        cnpj: data.cnpj
      }
    }).then(() => {
      context.commit('insertFavorites', data)
      context.dispatch('getFavorites')
    })
  },
  async insertFavoritesAdmin (context, payload) {
    const { user, data } = payload

    await apolloClient.mutate({
      mutation: gql`mutation insertFavorites($user_id: uuid, $cnpj: String!) {
        insert_favorites(
          objects: {
            user_id: $user_id
            company_cnpj: $cnpj
          }
        ) {
          affected_rows
        }
      }`,
      variables: {
        user_id: user.id,
        cnpj: data.cnpj
      }
    }).then(() => {
      context.commit('insertFavorites', data)
      context.dispatch('getFavorites')
    })
  },
  async deleteFavorites (context, data) {
    await apolloClient.mutate({
      mutation: gql`mutation deleteFavorites($cnpj: String!) {
        delete_favorites(where: {
          company_cnpj: {
            _eq: $cnpj
          }
        }) {
          affected_rows
        }
      }`,
      variables: {
        cnpj: data.cnpj
      }
    }).then(() => {
      context.commit('deleteFavorites', data)
      context.dispatch('getFavorites')
    })
  },
  async getAdverts (context, cnpj) {
    await apolloClient.query({
      query: gql`${getAdverts}`,
      variables: {
        cnpj: cnpj
      }
    }).then(response => {
      const query = response.data

      context.commit('setAdverts', query.adverts)
    })
  }
}

export default actions
